window.addEventListener('load', function () {
  function openFirstQuestion(selector) {
    const menu = document.querySelector(selector)
    if (menu) {
      menu.querySelector('.questions-item__text').classList.add('active')
      menu.querySelector('.questions-item__button').classList.add('active')
    }
  }

  const dropdownMenuButtons = document.querySelectorAll('.js-dropdown-menu-buttons')

  if (dropdownMenuButtons.length) {
    for (var i = 0; i < dropdownMenuButtons.length; i++) {
      dropdownMenuButtons[i].addEventListener('click', function () {
        var parent = this.closest('.questions__item')
        var text = parent.querySelector('.questions-item__text')
        var button = parent.querySelector('.questions-item__button')
        button.classList.toggle('active')
        text.classList.toggle('active')
      })
    }
  }

  window.requestAnimationFrame(function () {openFirstQuestion('.services .questions__item')})
})
